import Flexer from 'js/components/Flexer/Flexer'
import Tag from 'js/components/Tag/Tag'
import { useRoleLabelAll } from 'js/lib/helpers/useRoleLabel'

interface Props {
    roles?: string[] | null
    isOwner?: boolean
}

export const Roles = ({ roles = [], isOwner }: Props) => {
    const roleLabels = useRoleLabelAll(roles, isOwner)

    return (
        <Flexer
            gutter="tiny"
            justifyContent="flex-start"
            data-testid="roles"
            wrap
        >
            {roleLabels?.map((roleLabel) => (
                <Tag variant="primary" key={roleLabel}>
                    {roleLabel}
                </Tag>
            ))}
        </Flexer>
    )
}

export default Roles
